import React from "react";

const CheckIconWhite = () => {
    return (
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.36675 6.34368L9.12575 0.58468C9.22486 0.485458 9.34086 0.434792 9.47375 0.432681C9.60664 0.430569 9.72481 0.481236 9.82825 0.58468C9.9317 0.688125 9.98342 0.806903 9.98342 0.941014C9.98342 1.07524 9.9317 1.19407 9.82825 1.29751L3.78859 7.34751C3.66803 7.46796 3.52742 7.52818 3.36675 7.52818C3.20609 7.52818 3.06547 7.46796 2.94492 7.34751L0.161586 4.56418C0.0624747 4.46496 0.0135858 4.34718 0.0149191 4.21085C0.0161413 4.07462 0.0684746 3.95479 0.171919 3.85135C0.275364 3.7479 0.394141 3.69618 0.528252 3.69618C0.662475 3.69618 0.781308 3.7479 0.884752 3.85135L3.36675 6.34368Z" fill="white" />
        </svg>
    )
}
export default CheckIconWhite;